//T.32832 - Componente para tracking administrativo con Google Maps
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { TrackingAdmService } from '../../service/tracking-adm.service';
import { TrackingCamionService } from '../../service/tracking-camion.service';
import { GoogleMapsHelperService } from '../../service/google-maps-helper.service';
import { GoogleMapsConfigService } from '../../service/google-maps-config.service';
import { ICamionTracking, IGarita } from '../../model/tracking-adm.model';
import { ITrackingViajes } from '../../model/modelTracking';
import { ColDef, GridApi, GridReadyEvent } from 'ag-grid-community';
import { UsuarioBasculaGaritaService } from 'src/app/aplicaciones-modulos/balanza/services/usuario-bascula-garita.service';
import { EquiposMarquesinaService } from '../../service/equiposMarquesinas.service';
import { LogisticaService } from '../../service/logistica.services';
import { IBasculaSentidoRequest, IMensajesRequest } from '../../model/modelOnlyServices';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-tracking-adm',
  templateUrl: './tracking-adm.component.html',
  styleUrls: ['./tracking-adm.component.css']
})
export class TrackingAdmComponent implements OnInit, OnDestroy, AfterViewInit {

  //T.32832 - ═══════════════════════════════════════════════════════════
  //T.32832 - CONFIGURACIÓN DE PARÁMETROS CENTRALIZADOS
  //T.32832 - ═══════════════════════════════════════════════════════════
  
  //T.32832 - Configuración del Mapa (Google Maps)
  private readonly CONFIG_MAPA = {
    ZOOM_INICIAL: 14,                 // Nivel de zoom inicial del mapa
    ZOOM_CAMION_SELECCIONADO: 16,     // Nivel de zoom al seleccionar un camión
    INIT_DELAY_MS: 100                // Delay para inicializar mapa después de la vista
  };

  //T.32832 - Configuración de Intervalos de Actualización (en milisegundos)
  private readonly CONFIG_INTERVALS = {
    RECARGAR_VIAJES_MS: 60000        // Recargar viajes cada 60 segundos
  };

  //T.32832 - Configuración de Alertas (SweetAlert2)
  private readonly CONFIG_ALERTAS = {
    TOAST_TIMER_MS: 3000              // Tiempo de auto-cierre para toast notifications
  };

  //T.32832 - ═══════════════════════════════════════════════════════════
  //T.32832 - FIN DE CONFIGURACIÓN
  //T.32832 - ═══════════════════════════════════════════════════════════

  //T.32832 - Variables del mapa (Google Maps)
  public map: google.maps.Map | null = null;
  public garita: IGarita;
  public marcadorGarita: google.maps.Marker | null = null;
  public circuloGeofence: google.maps.Circle | null = null;
  public marcadoresCamiones: Map<string, google.maps.Marker> = new Map();

  //T.32832 - Variables de datos
  public camiones: ICamionTracking[] = [];
  public camionSeleccionado: ICamionTracking | null = null;
  public viajes: ITrackingViajes[] = [];
  public viajesCreado: ITrackingViajes[] = [];
  public viajesEnCola: ITrackingViajes[] = [];
  public viajesEnRuta: ITrackingViajes[] = [];
  public viajesRevisionHabilitada: ITrackingViajes[] = [];
  public viajeSeleccionado: ITrackingViajes | null = null;
  public loading: boolean = false;
  public loadingViajes: boolean = false;
  
  //T.32832 - Marcadores de viajes en el mapa (Google Maps)
  public marcadoresViajes: Map<number, google.maps.Marker> = new Map();
  
  //T.32832 - Variables para tabs
  public tabActiva: 'CREADO' | 'EN_COLA' | 'EN_RUTA' | 'REVISION_HABILITADA' = 'CREADO';
  
  //T.32832 - Variable para control de permisos
  private esAdministradorLogistica: boolean = false;
  
  //T.32832 - Variables para AG-Grid de viajes CREADO
  public columnDefsViajesCreado: ColDef[] = [];
  public defaultColDefViajes: ColDef = {};
  public gridApiViajesCreado!: GridApi;
  
  //T.32832 - Variables para AG-Grid de viajes EN_COLA (con flechas)
  public columnDefsViajesEnCola: ColDef[] = [];
  public gridApiViajesEnCola!: GridApi;
  
  //T.32832 - Variables para AG-Grid de viajes EN_RUTA (sin flechas)
  public columnDefsViajesEnRuta: ColDef[] = [];
  public gridApiViajesEnRuta!: GridApi;
  
  //T.32832 - Variables para AG-Grid de viajes REVISION_HABILITADA (sin flechas)
  public columnDefsViajesRevisionHabilitada: ColDef[] = [];
  public gridApiViajesRevisionHabilitada!: GridApi;

  //T.32832 - Suscripciones
  private trackingSubscription: Subscription = new Subscription();

  public usarioActual   : any;
  constructor(
    private trackingService: TrackingAdmService,
    private trackingCamionService: TrackingCamionService,
    private googleMapsHelper: GoogleMapsHelperService,
    private googleMapsConfig: GoogleMapsConfigService,

    /**Integracion de servicios con equipos y sensores */
    private logisticaAPI  : LogisticaService,
    private utilServices  : UtilsService, 
    private tokenService  : TokenService,
    private usuarioBasculaAPI: UsuarioBasculaGaritaService,
    private onlyControlSensoresAPI: EquiposMarquesinaService,   
  ) {
    this.loading = false; // Inicializar loading como false
    this.garita = this.trackingService.getGarita();
    //T.32832 - Verificar si el usuario tiene rol de administrador de logística
    this.esAdministradorLogistica = this.verificarRolAdministrador();
    this.initializeViajesGridCreadoConfig();
    this.initializeViajesGridEnColaConfig();
    this.initializeViajesGridEnRutaConfig();
    this.initializeViajesGridRevisionHabilitadaConfig();
  }

  ngOnInit(): void {
    //T.32832 - Verificar que el servicio esté disponible
    if (!this.trackingService) {
      console.error('T.32832 - TrackingAdmService no está disponible');
      this.loading = false;
      Swal.fire('Error', 'Servicio de tracking no disponible', 'error');
      return;
    }
    
    //T.32832 - Carga inicial de datos
    this.cargarCamionesInicial();
    this.cargarViajes();

    //Para integración con Only Controls
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.getUsuarioBascula();
    this.getAllMensajesMarquesinas();
  }

  ngAfterViewInit(): void {
    //T.32832 - Inicializa el mapa después de que la vista esté lista
    setTimeout(() => {
      this.inicializarMapa();
    }, this.CONFIG_MAPA.INIT_DELAY_MS);
  }

  ngOnDestroy(): void {
    //T.32832 - Limpia suscripciones
    if (this.trackingSubscription) {
      this.trackingSubscription.unsubscribe();
    }
  }

  //T.32832 - Inicializa Google Maps
  private async inicializarMapa(): Promise<void> {
    try {
      const center: google.maps.LatLngLiteral = {
        lat: this.garita.latitud,
        lng: this.garita.longitud
      };

      //T.32832 - Inicializar mapa con el helper service (carga el script una sola vez)
      this.map = await this.googleMapsHelper.initializeMap('mapa-tracking', center);
      //T.32832 - Crea marcador de la garita
      this.crearMarcadorGarita();

      //T.32832 - Crea círculo de geofence
      this.crearCirculoGeofence();

      //T.32832 - Actualiza marcadores si ya hay viajes cargados
      if (this.viajesCreado.length > 0 || this.viajesEnCola.length > 0 || this.viajesEnRuta.length > 0 || this.viajesRevisionHabilitada.length > 0) {
        this.actualizarMarcadoresViajes();
      }

      //T.32832 - Inicia el tracking automático
      this.iniciarTrackingAutomatico();
    } catch (error) {
      console.error('T.32832 - Error al inicializar Google Maps:', error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo cargar el mapa. Verifica la configuración de Google Maps API.',
        icon: 'error'
      });
    }
  }

  //T.32832 - Crea marcador de la garita (Google Maps)
  private crearMarcadorGarita(): void {
    if (!this.map) {
      console.error('T.32832 - No se puede crear marcador de garita: mapa no inicializado');
      return;
    }

    const position: google.maps.LatLngLiteral = {
      lat: this.garita.latitud,
      lng: this.garita.longitud
    };

    //T.32832 - Crear marcador con icono personalizado
    this.marcadorGarita = new google.maps.Marker({
      position: position,
      map: this.map,
      title: this.garita.nombre,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 12,
        fillColor: '#dc3545',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2
      }
    });

    //T.32832 - Crear InfoWindow
    const infoContent = `
      <div class="text-center" style="padding: 5px;">
        <h6 style="margin: 5px 0;"><i class="fas fa-building mr-1"></i>${this.garita.nombre}</h6>
        <small>Radio: ${this.garita.radioMetros}m</small>
      </div>
    `;
    
    this.googleMapsHelper.createInfoWindow(this.marcadorGarita, infoContent);
  }

  //T.32832 - Crea círculo de geofence (Google Maps)
  private crearCirculoGeofence(): void {
    if (!this.map) {
      console.error('T.32832 - No se puede crear círculo de geofence: mapa no inicializado');
      return;
    }

    const center: google.maps.LatLngLiteral = {
      lat: this.garita.latitud,
      lng: this.garita.longitud
    };

    this.circuloGeofence = this.googleMapsHelper.createCircle(
      this.map,
      center,
      this.garita.radioMetros,
      {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.1
      }
    );
  }

  //T.32832 - Carga inicial de camiones - DESHABILITADO
  private cargarCamionesInicial(): void {
    // T.32832 - Carga de camiones simulados deshabilitada por solicitud del usuario
    this.loading = false;
    this.camiones = []; // Inicializar array vacío

  }

  //T.32832 - Inicia tracking automático
  private iniciarTrackingAutomatico(): void {
    // Recargar viajes periódicamente
    setInterval(() => {
      this.cargarViajes();
    }, this.CONFIG_INTERVALS.RECARGAR_VIAJES_MS);
  }

  //T.32832 - Carga todos los viajes con información de área y filtra por estado
  private cargarViajes(): void {
    this.loadingViajes = true;
    
    if (!this.trackingCamionService) {
      console.error('T.32832 - TrackingCamionService no está disponible');
      this.loadingViajes = false;
      return;
    }
    
    // Cargar todos los viajes con información de área
    this.trackingCamionService.getViajesConArea().subscribe({
      next: (viajes) => {
        // Filtrar y ordenar viajes CREADO
        this.viajesCreado = (viajes || [])
          .filter(v => v.estado === 'CREADO')
          .sort((a, b) => (a.posicion || 0) - (b.posicion || 0));
        
        // Filtrar y ordenar viajes EN_COLA
        this.viajesEnCola = (viajes || [])
          .filter(v => v.estado === 'EN_COLA')
          .sort((a, b) => (a.posicion || 0) - (b.posicion || 0));
        
        // Filtrar y ordenar viajes EN_RUTA
        this.viajesEnRuta = (viajes || [])
          .filter(v => v.estado === 'EN_RUTA')
          .sort((a, b) => (a.posicion || 0) - (b.posicion || 0));
        
        // Filtrar y ordenar viajes REVISION_HABILITADA
        this.viajesRevisionHabilitada = (viajes || [])
          .filter(v => v.estado === 'REVISION_HABILITADA')
          .sort((a, b) => (a.posicion || 0) - (b.posicion || 0));
        // Actualizar marcadores en el mapa con viajes que tienen coordenadas
        this.actualizarMarcadoresViajes();
        
        this.loadingViajes = false;
      },
      error: (error) => {
        console.error('T.32832 - Error cargando viajes con área:', error);
        this.viajesCreado = [];
        this.viajesEnCola = [];
        this.viajesEnRuta = [];
        this.viajesRevisionHabilitada = [];
        this.loadingViajes = false;
      }
    });
  }

  //T.32832 - Selecciona un viaje
  public seleccionarViaje(viaje: ITrackingViajes): void {
    this.viajeSeleccionado = viaje;
  }

  //T.32832 - Cambiar tab activa
  public cambiarTab(tab: 'CREADO' | 'EN_COLA' | 'EN_RUTA' | 'REVISION_HABILITADA'): void {
    this.tabActiva = tab;
  }
  
  //T.32832 - Inicializa configuración del grid de viajes CREADO
  private initializeViajesGridCreadoConfig(): void {
    this.columnDefsViajesCreado = [
      {
        headerName: 'Viaje',
        field: 'idViaje',
        width: 80,
        sortable: false,
        cellStyle: { textAlign: 'center' }
      },
      {
        headerName: 'Placa',
        field: 'placa',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Distanc Km',
        field: 'distancia',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Área',
        field: 'areaDescripcion',
        width: 130,
        sortable: false,
        cellStyle: (params) => {
          if (params.data && params.data.areaColor) {
            return { 
              backgroundColor: params.data.areaColor,
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center'
            };
          }
          return null;
        }
      },
      {
        headerName: 'Capacidad',
        width: 140,
        sortable: false,
        valueGetter: (params) => {
          if (params.data) {
            const ocupada = params.data.areaCapacidadOcupada || 0;
            const total = params.data.areaCapacidadTotal || 0;
            const libre = params.data.areaCapacidadLibre || 0;
            return `${ocupada}/${total} (Libre: ${libre})`;
          }
          return 'N/A';
        }
      },
      {
        headerName: 'Ticket',
        field: 'choferTicket',
        width: 100,
        sortable: false,
        valueFormatter: (params) => params.value || 'N/A'
      },
      {
        headerName: 'Acciones',
        width: 120,
        sortable: false,
        cellRenderer: (params: any) => {
          // Habilitar botón Gen. Ticket solo si está en estado válido Y no tiene ticket generado
          const estado = params.data.estado || '';
          const choferTicket = params.data.choferTicket;
          const estadoValido = estado === 'CREADO' || estado === 'EN_RUTA';
          const noTieneTicket = !choferTicket || choferTicket === '' || choferTicket === 'N/A';
          const habilitarTicket = estadoValido && noTieneTicket;
          const ticketDisabled = habilitarTicket ? '' : 'disabled';
          let ticketTitle = 'Generar ticket para el chofer';
          if (!estadoValido) {
            ticketTitle = 'Solo disponible para viajes CREADO o EN_RUTA';
          } else if (!noTieneTicket) {
            ticketTitle = 'El viaje ya tiene un ticket generado';
          }
          
          return `
            <div style="display: flex; justify-content: center;">
              <button class="btn btn-sm btn-primary" 
                      data-action="gen-ticket" 
                      data-id="${params.data.idViaje}"
                      ${ticketDisabled}
                      title="${ticketTitle}"
                      style="padding: 3px 8px; font-size: 0.75rem;">
                <i class="fas fa-ticket-alt mr-1"></i> Gen. Ticket
              </button>
            </div>`;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target;
          const button = target.closest('button');
          if (button && !button.disabled) {
            const action = button.dataset.action;
            const idViaje = parseInt(button.dataset.id);
            
            if (action === 'gen-ticket') {
              this.generarTicketManual(idViaje);
            }
          }
        }
      },
      {
        headerName: 'Chofer',
        field: 'choferNombre',
        width: 200,
        sortable: false,
        valueFormatter: (params) => params.value || 'Sin chofer'
      },
      {
        headerName: 'Teléfono',
        field: 'choferTelefono',
        width: 130,
        sortable: false
      },
      {
        headerName: 'Prioridad',
        field: 'prioridad',
        width: 130,
        sortable: false,
        cellStyle: { textAlign: 'center' },
        valueFormatter: (params) => {
          const prioridad = params.value;
          switch(prioridad) {
            case 1: return 'CRÍTICO';
            case 2: return 'ALTA';
            case 3: return 'MEDIO';
            case 4: return 'NORMAL';
            case 5: return 'BAJA';
            default: return 'N/A';
          }
        }
      }
    ];
  }
  
  //T.32832 - Inicializa configuración del grid de viajes EN_COLA (con flechas)
  private initializeViajesGridEnColaConfig(): void {
    this.columnDefsViajesEnCola = [
      {
        headerName: 'Viaje',
        field: 'idViaje',
        width: 80,
        sortable: false,
        cellStyle: { textAlign: 'center' }
      },
      {
        headerName: 'Placa',
        field: 'placa',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Distanc Km',
        field: 'distancia',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Área',
        field: 'areaDescripcion',
        width: 130,
        sortable: false,
        cellStyle: (params) => {
          if (params.data && params.data.areaColor) {
            return { 
              backgroundColor: params.data.areaColor,
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center'
            };
          }
          return null;
        }
      },
      {
        headerName: 'Capacidad',
        width: 140,
        sortable: false,
        valueGetter: (params) => {
          if (params.data) {
            const ocupada = params.data.areaCapacidadOcupada || 0;
            const total = params.data.areaCapacidadTotal || 0;
            const libre = params.data.areaCapacidadLibre || 0;
            return `${ocupada}/${total} (Libre: ${libre})`;
          }
          return 'N/A';
        }
      },
      {
        headerName: 'Ticket',
        field: 'choferTicket',
        width: 100,
        sortable: false,
        valueFormatter: (params) => params.value || 'N/A'
      },
      {
        headerName: 'Acciones',
        width: 200,
        sortable: false,
        cellRenderer: (params: any) => {
          const capacidadLibre = params.data.areaCapacidadLibre || 0;
          const tieneCapacidad = capacidadLibre > 0;
          const buttonClass = tieneCapacidad ? 'btn-success' : 'btn-secondary';
          const disabledAttr = tieneCapacidad ? '' : 'disabled';
          const title = tieneCapacidad ? 'Habilitar viaje' : 'Sin capacidad disponible en el área';
          
          // Habilitar botón Gen. Ticket solo si está en estado válido Y no tiene ticket generado
          const estado = params.data.estado || '';
          const choferTicket = params.data.choferTicket;
          const estadoValido = estado === 'CREADO' || estado === 'EN_RUTA' || estado === 'EN_COLA';
          const noTieneTicket = !choferTicket || choferTicket === '' || choferTicket === 'N/A';
          const habilitarTicket = estadoValido && noTieneTicket;
          const ticketDisabled = habilitarTicket ? '' : 'disabled';
          let ticketTitle = 'Generar ticket para el chofer';
          if (!estadoValido) {
            ticketTitle = 'Solo disponible para viajes CREADO, EN_RUTA o EN_COLA';
          } else if (!noTieneTicket) {
            ticketTitle = 'El viaje ya tiene un ticket generado';
          }
          
          return `
            <div style="display: flex; gap: 4px; justify-content: center;">
              <button class="btn btn-sm btn-primary" 
                      data-action="gen-ticket" 
                      data-id="${params.data.idViaje}"
                      ${ticketDisabled}
                      title="${ticketTitle}"
                      style="padding: 3px 8px; font-size: 0.75rem;">
                <i class="fas fa-ticket-alt mr-1"></i> Gen. Ticket
              </button>
              <button class="btn btn-sm ${buttonClass}" 
                      data-action="habilitar" 
                      data-id="${params.data.idViaje}"
                      data-capacidad="${capacidadLibre}"
                      ${disabledAttr}
                      title="${title}"
                      style="padding: 3px 8px; font-size: 0.75rem;">
                <i class="fas fa-check mr-1"></i> Habilitar
              </button>
            </div>`;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target;
          const button = target.closest('button');
          if (button && !button.disabled) {
            const action = button.dataset.action;
            const idViaje = parseInt(button.dataset.id);
            
            if (action === 'gen-ticket') {
              this.generarTicketManual(idViaje);
            } else if (action === 'habilitar') {
              const capacidadLibre = parseInt(button.dataset.capacidad);
              if (capacidadLibre > 0) {
                this.habilitarViaje(idViaje);
              }
            }
          }
        }
      },
      {
        headerName: 'Orden',
        width: 100,
        sortable: false,
        cellRenderer: (params: any) => {
          const rowIndex = params.node.rowIndex;
          const totalRows = params.api.getDisplayedRowCount();
          const deshabilitadoPorRol = !this.esAdministradorLogistica;
          const opacity = deshabilitadoPorRol ? '0.5' : '1';
          const cursor = deshabilitadoPorRol ? 'not-allowed' : 'pointer';
          const title = deshabilitadoPorRol ? 'Solo administradores pueden modificar el orden' : '';
          
          return `
            <div style="display: flex; gap: 4px; justify-content: center;" title="${title}">
              <button class="btn btn-sm btn-primary" 
                      data-action="mover-arriba" 
                      data-id="${params.data.idViaje}"
                      ${rowIndex === 0 || deshabilitadoPorRol ? 'disabled' : ''}
                      style="padding: 2px 6px; font-size: 0.7rem; opacity: ${opacity}; cursor: ${cursor};">
                <i class="fas fa-arrow-up"></i>
              </button>
              <button class="btn btn-sm btn-primary" 
                      data-action="mover-abajo" 
                      data-id="${params.data.idViaje}"
                      ${rowIndex === totalRows - 1 || deshabilitadoPorRol ? 'disabled' : ''}
                      style="padding: 2px 6px; font-size: 0.7rem; opacity: ${opacity}; cursor: ${cursor};">
                <i class="fas fa-arrow-down"></i>
              </button>
            </div>`;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target;
          const button = target.closest('button');
          if (button) {
            const action = button.dataset.action;
            const idViaje = parseInt(button.dataset.id);
            
            if (action === 'mover-arriba') {
              this.moverViajeArriba(idViaje);
            } else if (action === 'mover-abajo') {
              this.moverViajeAbajo(idViaje);
            }
          }
        }
      },
      {
        headerName: 'Chofer',
        field: 'choferNombre',
        width: 200,
        sortable: false,
        valueFormatter: (params) => params.value || 'Sin chofer'
      },
      {
        headerName: 'Teléfono',
        field: 'choferTelefono',
        width: 130,
        sortable: false
      },
      {
        headerName: 'Prioridad',
        field: 'prioridad',
        width: 130,
        sortable: false,
        cellStyle: { textAlign: 'center' },
        valueFormatter: (params) => {
          const prioridad = params.value;
          switch(prioridad) {
            case 1: return 'CRÍTICO';
            case 2: return 'ALTA';
            case 3: return 'MEDIO';
            case 4: return 'NORMAL';
            case 5: return 'BAJA';
            default: return 'N/A';
          }
        }
      }
    ];

    this.defaultColDefViajes = {
      resizable: true
    };
  }
  
  //T.32832 - Inicializa configuración del grid de viajes EN_RUTA (sin flechas)
  private initializeViajesGridEnRutaConfig(): void {
    this.columnDefsViajesEnRuta = [
      {
        headerName: 'Viaje',
        field: 'idViaje',
        width: 80,
        sortable: false,
        cellStyle: { textAlign: 'center' }
      },
      {
        headerName: 'Placa',
        field: 'placa',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Distanc Km',
        field: 'distancia',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Área',
        field: 'areaDescripcion',
        width: 130,
        sortable: false,
        cellStyle: (params) => {
          if (params.data && params.data.areaColor) {
            return { 
              backgroundColor: params.data.areaColor,
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center'
            };
          }
          return null;
        }
      },
      {
        headerName: 'Capacidad',
        width: 140,
        sortable: false,
        valueGetter: (params) => {
          if (params.data) {
            const ocupada = params.data.areaCapacidadOcupada || 0;
            const total = params.data.areaCapacidadTotal || 0;
            const libre = params.data.areaCapacidadLibre || 0;
            return `${ocupada}/${total} (Libre: ${libre})`;
          }
          return 'N/A';
        }
      },
      {
        headerName: 'Ticket',
        field: 'choferTicket',
        width: 100,
        sortable: false,
        valueFormatter: (params) => params.value || 'N/A'
      },
      {
        headerName: 'Acciones',
        width: 120,
        sortable: false,
        cellRenderer: (params: any) => {
          // Habilitar botón Gen. Ticket solo si está en estado válido Y no tiene ticket generado
          const estado = params.data.estado || '';
          const choferTicket = params.data.choferTicket;
          const estadoValido = estado === 'CREADO' || estado === 'EN_RUTA';
          const noTieneTicket = !choferTicket || choferTicket === '' || choferTicket === 'N/A';
          const habilitarTicket = estadoValido && noTieneTicket;
          const ticketDisabled = habilitarTicket ? '' : 'disabled';
          let ticketTitle = 'Generar ticket para el chofer';
          if (!estadoValido) {
            ticketTitle = 'Solo disponible para viajes CREADO o EN_RUTA';
          } else if (!noTieneTicket) {
            ticketTitle = 'El viaje ya tiene un ticket generado';
          }
          
          return `
            <div style="display: flex; justify-content: center;">
              <button class="btn btn-sm btn-primary" 
                      data-action="gen-ticket" 
                      data-id="${params.data.idViaje}"
                      ${ticketDisabled}
                      title="${ticketTitle}"
                      style="padding: 3px 8px; font-size: 0.75rem;">
                <i class="fas fa-ticket-alt mr-1"></i> Gen. Ticket
              </button>
            </div>`;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target;
          const button = target.closest('button');
          if (button && !button.disabled) {
            const action = button.dataset.action;
            const idViaje = parseInt(button.dataset.id);
            
            if (action === 'gen-ticket') {
              this.generarTicketManual(idViaje);
            }
          }
        }
      },
      {
        headerName: 'Chofer',
        field: 'choferNombre',
        width: 200,
        sortable: false,
        valueFormatter: (params) => params.value || 'Sin chofer'
      },
      {
        headerName: 'Teléfono',
        field: 'choferTelefono',
        width: 130,
        sortable: false
      },
      {
        headerName: 'Prioridad',
        field: 'prioridad',
        width: 130,
        sortable: false,
        cellStyle: { textAlign: 'center' },
        valueFormatter: (params) => {
          const prioridad = params.value;
          switch(prioridad) {
            case 1: return 'CRÍTICO';
            case 2: return 'ALTA';
            case 3: return 'MEDIO';
            case 4: return 'NORMAL';
            case 5: return 'BAJA';
            default: return 'N/A';
          }
        }
      }
    ];
  }

  //T.32832 - Inicializa configuración del grid de viajes REVISION_HABILITADA (sin flechas)
  private initializeViajesGridRevisionHabilitadaConfig(): void {
    this.columnDefsViajesRevisionHabilitada = [
      {
        headerName: 'Viaje',
        field: 'idViaje',
        width: 80,
        sortable: false,
        cellStyle: { textAlign: 'center' }
      },
      {
        headerName: 'Placa',
        field: 'placa',
        width: 100,
        sortable: false
      },
      {
        headerName: 'Distanc Km',
        field: 'distancia',
        width: 150,
        sortable: false
      },
      {
        headerName: 'Área',
        field: 'areaDescripcion',
        width: 130,
        sortable: false,
        cellStyle: (params) => {
          if (params.data && params.data.areaColor) {
            return { 
              backgroundColor: params.data.areaColor,
              color: 'white',
              fontWeight: 'bold',
              textAlign: 'center'
            };
          }
          return null;
        }
      },
      {
        headerName: 'Capacidad',
        width: 140,
        sortable: false,
        valueGetter: (params) => {
          if (params.data) {
            const ocupada = params.data.areaCapacidadOcupada || 0;
            const total = params.data.areaCapacidadTotal || 0;
            const libre = params.data.areaCapacidadLibre || 0;
            return `${ocupada}/${total} (Libre: ${libre})`;
          }
          return 'N/A';
        }
      },
      {
        headerName: 'Ticket',
        field: 'choferTicket',
        width: 100,
        sortable: false,
        valueFormatter: (params) => params.value || 'N/A'
      },
      {
        headerName: 'Acciones',
        width: 120,
        sortable: false,
        cellRenderer: (params: any) => {
          // Habilitar botón Gen. Ticket solo si está en estado válido Y no tiene ticket generado
          const estado = params.data.estado || '';
          const choferTicket = params.data.choferTicket;
          const estadoValido = estado === 'CREADO' || estado === 'EN_RUTA';
          const noTieneTicket = !choferTicket || choferTicket === '' || choferTicket === 'N/A';
          const habilitarTicket = estadoValido && noTieneTicket;
          const ticketDisabled = habilitarTicket ? '' : 'disabled';
          let ticketTitle = 'Generar ticket para el chofer';
          if (!estadoValido) {
            ticketTitle = 'Solo disponible para viajes CREADO o EN_RUTA';
          } else if (!noTieneTicket) {
            ticketTitle = 'El viaje ya tiene un ticket generado';
          }
          
          return `
            <div style="display: flex; justify-content: center;">
              <button class="btn btn-sm btn-primary" 
                      data-action="gen-ticket" 
                      data-id="${params.data.idViaje}"
                      ${ticketDisabled}
                      title="${ticketTitle}"
                      style="padding: 3px 8px; font-size: 0.75rem;">
                <i class="fas fa-ticket-alt mr-1"></i> Gen. Ticket
              </button>
            </div>`;
        },
        onCellClicked: (params: any) => {
          const target = params.event.target;
          const button = target.closest('button');
          if (button && !button.disabled) {
            const action = button.dataset.action;
            const idViaje = parseInt(button.dataset.id);
            
            if (action === 'gen-ticket') {
              this.generarTicketManual(idViaje);
            }
          }
        }
      },
      {
        headerName: 'Chofer',
        field: 'choferNombre',
        width: 200,
        sortable: false,
        valueFormatter: (params) => params.value || 'Sin chofer'
      },
      {
        headerName: 'Teléfono',
        field: 'choferTelefono',
        width: 130,
        sortable: false
      },
      {
        headerName: 'Prioridad',
        field: 'prioridad',
        width: 130,
        sortable: false,
        cellStyle: { textAlign: 'center' },
        valueFormatter: (params) => {
          const prioridad = params.value;
          switch(prioridad) {
            case 1: return 'CRÍTICO';
            case 2: return 'ALTA';
            case 3: return 'MEDIO';
            case 4: return 'NORMAL';
            case 5: return 'BAJA';
            default: return 'N/A';
          }
        }
      }
    ];
  }

  //T.32832 - Evento cuando el grid de viajes CREADO está listo
  public onGridViajesCreadoReady(params: GridReadyEvent): void {
    this.gridApiViajesCreado = params.api;
  }

  //T.32832 - Evento cuando el grid de viajes EN_COLA está listo
  public onGridViajesEnColaReady(params: GridReadyEvent): void {
    this.gridApiViajesEnCola = params.api;
  }
  
  //T.32832 - Evento cuando el grid de viajes EN_RUTA está listo
  public onGridViajesEnRutaReady(params: GridReadyEvent): void {
    this.gridApiViajesEnRuta = params.api;
  }

  //T.32832 - Evento cuando el grid de viajes REVISION_HABILITADA está listo
  public onGridViajesRevisionHabilitadaReady(params: GridReadyEvent): void {
    this.gridApiViajesRevisionHabilitada = params.api;
  }

  //T.32832 - Verifica si el usuario tiene el rol LOGIS_ROL_ADMIN
  private verificarRolAdministrador(): boolean {
    try {
      const datosUsuario = JSON.parse(localStorage.getItem('datosUsuarioLogin') || '{}');
      
      //T.45894 Se verifica del token y no se datosUsuarioLogin
      const authRol = this.tokenService.includeRole('LOGIS_ROL_ADMIN');
      console.info('T.45894 - Posee autority ==>', authRol);
      return authRol;

      if (!datosUsuario || !datosUsuario.authorities) {
        return false;
      }
      
      // Verificar si el usuario tiene el rol LOGIS_ROL_ADMIN
      const tieneRol = datosUsuario.authorities.some(
        (auth: any) => auth.name === 'LOGIS_ROL_ADMIN'
      );
      
      return tieneRol;
    } catch (error) {
      console.error('T.32832 - Error al verificar rol de administrador:', error);
      return false;
    }
  }

  //T.32832 - Mueve un viaje hacia arriba en la cola
  private moverViajeArriba(idViaje: number): void {
    //T.32832 - Validar que el usuario tenga permisos de administrador
    if (!this.esAdministradorLogistica) {
      console.warn('T.32832 - Usuario sin permisos para modificar el orden');
      Swal.fire({
        title: 'Acceso Denegado',
        text: 'Solo los administradores de logística pueden modificar el orden de los viajes.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    
    const index = this.viajesEnCola.findIndex(v => v.idViaje === idViaje);
    if (index <= 0) return;

    // Intercambiar posiciones
    const temp = this.viajesEnCola[index];
    this.viajesEnCola[index] = this.viajesEnCola[index - 1];
    this.viajesEnCola[index - 1] = temp;

    // Actualizar posiciones en el array
    this.viajesEnCola.forEach((viaje, idx) => {
      viaje.posicion = idx + 1;
    });

    // Refrescar grid
    this.gridApiViajesEnCola.setRowData(this.viajesEnCola);
    // Llamar servicio para actualizar en backend
    this.actualizarColaEnBackend();
  }

  //T.32832 - Mueve un viaje hacia abajo en la cola
  private moverViajeAbajo(idViaje: number): void {
    //T.32832 - Validar que el usuario tenga permisos de administrador
    if (!this.esAdministradorLogistica) {
      console.warn('T.32832 - Usuario sin permisos para modificar el orden');
      Swal.fire({
        title: 'Acceso Denegado',
        text: 'Solo los administradores de logística pueden modificar el orden de los viajes.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    
    const index = this.viajesEnCola.findIndex(v => v.idViaje === idViaje);
    if (index < 0 || index >= this.viajesEnCola.length - 1) return;

    // Intercambiar posiciones
    const temp = this.viajesEnCola[index];
    this.viajesEnCola[index] = this.viajesEnCola[index + 1];
    this.viajesEnCola[index + 1] = temp;

    // Actualizar posiciones en el array
    this.viajesEnCola.forEach((viaje, idx) => {
      viaje.posicion = idx + 1;
    });

    // Refrescar grid
    this.gridApiViajesEnCola.setRowData(this.viajesEnCola);
    // Llamar servicio para actualizar en backend
    this.actualizarColaEnBackend();
  }

  //T.32832 - Actualiza la cola en el backend
  private actualizarColaEnBackend(): void {
    this.trackingCamionService.actualizarCola(this.viajesEnCola).subscribe({
      next: (response) => {
        // Recargar viajes para obtener datos actualizados del backend
        this.cargarViajes();
      },
      error: (error) => {
        console.error('T.32832 - Error al actualizar cola:', error);
        // Podrías mostrar un mensaje de error al usuario aquí
      }
    });
  }

  //T.32832 - Genera ticket manualmente para un viaje
  private generarTicketManual(idViaje: number): void {
    // Buscar el viaje en los arrays
    const viaje = this.viajesCreado.find(v => v.idViaje === idViaje) ||
                  this.viajesEnCola.find(v => v.idViaje === idViaje) ||
                  this.viajesEnRuta.find(v => v.idViaje === idViaje) ||
                  this.viajesRevisionHabilitada.find(v => v.idViaje === idViaje);
    
    if (!viaje) {
      console.error('T.32832 - Viaje no encontrado:', idViaje);
      Swal.fire({
        title: 'Error',
        text: 'No se encontró el viaje seleccionado.',
        icon: 'error',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    
    // Mostrar mensaje de confirmación
    Swal.fire({
      title: '¿Generar ticket?',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p style="margin-bottom: 15px; font-weight: 500;">
            ¿Desea generar el ticket para el chofer?
          </p>
          <div style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; margin-top: 10px;">
            <p style="margin: 8px 0;"><strong>Placa:</strong> ${viaje.placa || 'N/A'}</p>
            <p style="margin: 8px 0;"><strong>Chofer:</strong> ${viaje.choferNombre || 'N/A'}</p>
            <p style="margin: 8px 0;"><strong>Estado:</strong> ${viaje.estado || 'N/A'}</p>
          </div>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Generar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#007bff',
      cancelButtonColor: '#6c757d',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Usuario confirmó, proceder con la generación del ticket
        this.trackingCamionService.generarTicketChofer(idViaje).subscribe({
          next: (response: any) => {
            // Extraer el ticket del chofer (la respuesta ya es el objeto ITicketData directamente)
            const ticketGenerado = response.choferTicket || 'N/A';
            // Mostrar mensaje de éxito con el número de ticket
            Swal.fire({
              title: '¡Ticket Generado!',
              html: `
                <div style="text-align: center;">
                  <p style="font-size: 1.2rem; font-weight: bold; margin: 10px 0;">
                    Ticket: ${ticketGenerado}
                  </p>
                  <p style="margin-top: 10px;">El ticket ha sido generado exitosamente.</p>
                </div>
              `,
              icon: 'success',
              confirmButtonText: 'Aceptar'
            });
            
            // Recargar viajes para obtener datos actualizados del backend
            this.cargarViajes();
          },
          error: (error) => {
            console.error('T.32832 - Error al generar ticket:', error);
            Swal.fire({
              title: 'Error',
              text: error.error?.mensaje || 'Error al generar el ticket. Por favor intente nuevamente.',
              icon: 'error',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      } else {
        // Usuario canceló
      }
    });
  }

  //T.32832 - Habilita un viaje (cambia estado a REVISION_HABILITADA)
  private habilitarViaje(idViaje: number): void {
    // Verificar que el viaje existe y tiene capacidad libre
    const viaje = this.viajesEnCola.find(v => v.idViaje === idViaje);
    if (!viaje) {
      console.error('T.32832 - Viaje no encontrado:', idViaje);
      return;
    }
    
    const capacidadLibre = viaje.areaCapacidadLibre || 0;
    if (capacidadLibre <= 0) {
      console.warn('T.32832 - No hay capacidad libre en el área. Capacidad libre:', capacidadLibre);
      Swal.fire({
        title: 'Sin Capacidad',
        text: 'No se puede habilitar el viaje. No hay capacidad disponible en el área.',
        icon: 'warning',
        confirmButtonText: 'Aceptar'
      });
      return;
    }
    // Mostrar mensaje de confirmación con datos del viaje
    Swal.fire({
      title: '¿Confirmar habilitación?',
      html: `
        <div style="text-align: left; padding: 10px;">
          <p style="margin-bottom: 15px; font-weight: 500;">
            Confirma la habilitación del ingreso del camión seleccionado
          </p>
          <div style="background-color: #f8f9fa; padding: 15px; border-radius: 8px; margin-top: 10px;">
            <p style="margin: 8px 0;"><strong>Área:</strong> ${viaje.areaDescripcion || 'N/A'}</p>
            <p style="margin: 8px 0;"><strong>Placa:</strong> ${viaje.placa || 'N/A'}</p>
            <p style="margin: 8px 0;"><strong>Chofer:</strong> ${viaje.choferNombre || 'N/A'}</p>
            <p style="margin: 8px 0;"><strong>Ticket Chofer:</strong> ${viaje.choferTicket || 'N/A'}</p>
          </div>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        // Usuario confirmó, proceder con la habilitación
        this.trackingCamionService.habilitarViaje(idViaje).subscribe({
          next: (response) => {
            // Mostrar mensaje de éxito
            Swal.fire({
              title: '¡Habilitado!',
              text: 'El viaje ha sido habilitado exitosamente.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });
            
            // Recargar viajes para obtener datos actualizados del backend
            this.cargarViajes();
            this.enviarMensajeMarquesina(response.estado);
          },
          error: (error) => {
            console.error('T.32832 - Error al habilitar viaje:', error);
            Swal.fire({
              title: 'Error',
              text: 'Error al habilitar el viaje. Por favor intente nuevamente.',
              icon: 'error',
              confirmButtonText: 'Aceptar'
            });
          }
        });
      } else {
        // Usuario canceló, no hacer nada
      }
    });
  }

  //T.32832 - Actualiza marcadores de camiones en el mapa (Google Maps - DESHABILITADO)
  private actualizarMarcadoresCamiones(): void {
    //T.32832 - Función deshabilitada ya que no se usan camiones simulados
  }

  //T.32832 - Actualiza marcadores de viajes en el mapa (Google Maps - OPTIMIZADO)
  private actualizarMarcadoresViajes(): void {
    //T.32832 - Verificar que el mapa esté inicializado
    if (!this.map) {
      return;
    }

    //T.32832 - Combinar todos los arrays de viajes
    const todosLosViajes = [...this.viajesEnCola, ...this.viajesEnRuta, ...this.viajesRevisionHabilitada];
    
    //T.32832 - IDs de viajes actuales
    const idsViajesActuales = new Set(todosLosViajes.map(v => v.idViaje));
    
    //T.32832 - OPTIMIZACIÓN: Eliminar marcadores de viajes que ya no existen
    this.marcadoresViajes.forEach((marcador, idViaje) => {
      if (!idsViajesActuales.has(idViaje)) {
        marcador.setMap(null);
        this.marcadoresViajes.delete(idViaje);
      }
    });

    //T.32832 - Crear o actualizar marcadores solo para viajes con coordenadas
    todosLosViajes.forEach(viaje => {
      // Verificar que el viaje tenga latitud y longitud
      if (viaje.latitud && viaje.longitud) {
        const position: google.maps.LatLngLiteral = {
          lat: viaje.latitud,
          lng: viaje.longitud
        };
        
        // Determinar color según estado
        let fillColor = '#ffc107'; // EN_COLA default (amarillo)
        if (viaje.estado === 'EN_RUTA') {
          fillColor = '#007bff'; // Azul
        } else if (viaje.estado === 'REVISION_HABILITADA') {
          fillColor = '#28a745'; // Verde
        }

        //T.32832 - OPTIMIZACIÓN: Actualizar marcador si existe, sino crear uno nuevo
        if (this.marcadoresViajes.has(viaje.idViaje)) {
          // Actualizar posición existente
          const marcadorExistente = this.marcadoresViajes.get(viaje.idViaje)!;
          marcadorExistente.setPosition(position);
        } else {
          // Crear nuevo marcador con ícono de camión
          const marcador = new google.maps.Marker({
            position: position,
            map: this.map,
            title: `${viaje.placa} - ${viaje.estado}`,
            icon: {
              url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                  <path fill="${fillColor}" d="M40,18h-3v-4c0-1.1-0.9-2-2-2H13c-1.1,0-2,0.9-2,2v4H8c-1.1,0-2,0.9-2,2v12c0,1.1,0.9,2,2,2h2v4c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2v-4h2c1.1,0,2-0.9,2-2V20C42,18.9,41.1,18,40,18z M13,14h22v4H13V14z M14,38c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S15.1,38,14,38z M34,38c-1.1,0-2-0.9-2-2s0.9-2,2,2S35.1,38,34,38z M38,28H10v-6h28V28z"/>
                  <circle fill="#ffffff" cx="14" cy="36" r="1.5"/>
                  <circle fill="#ffffff" cx="34" cy="36" r="1.5"/>
                </svg>
              `),
              scaledSize: new google.maps.Size(36, 36),
              anchor: new google.maps.Point(18, 18)
            },
            optimized: true
          });

          //T.32832 - Crear InfoWindow
          const infoContent = `
            <div class="text-center" style="padding: 5px;">
              <h6 style="margin: 5px 0;"><i class="fas fa-truck mr-1"></i>${viaje.placa}</h6>
              <p style="margin: 3px 0;"><strong>Viaje:</strong> ${viaje.idViaje}</p>
              <p style="margin: 3px 0;"><strong>Chofer:</strong> ${viaje.choferNombre || 'N/A'}</p>
              <p style="margin: 3px 0;"><strong>Estado:</strong> ${viaje.estado}</p>
              <p style="margin: 3px 0;"><strong>Área:</strong> ${viaje.areaDescripcion || 'N/A'}</p>
            </div>
          `;
          
          this.googleMapsHelper.createInfoWindow(marcador, infoContent);
          this.marcadoresViajes.set(viaje.idViaje, marcador);
        }
      }
    });
  }

  //T.32832 - Verifica y muestra alertas de geofence - DESHABILITADO
  private verificarAlertas(camiones: ICamionTracking[]): void {
    // T.32832 - Alertas deshabilitadas por solicitud del usuario
    /*
    camiones.forEach(camion => {
      if (camion.enGeofence) {
        const alertaKey = `alerta_${camion.id}_${new Date().getTime()}`;
        if (!sessionStorage.getItem(alertaKey)) {
          Swal.fire({
            title: '¡Camión en Garita!',
            text: `Llegó el camión ${camion.placa}`,
            icon: 'success',
            timer: this.CONFIG_ALERTAS.TOAST_TIMER_MS,
            showConfirmButton: false,
            toast: true,
            position: 'top-end'
          });
          
          sessionStorage.setItem(alertaKey, 'true');
          
          setTimeout(() => {
            sessionStorage.removeItem(alertaKey);
          }, this.CONFIG_INTERVALS.SESSION_STORAGE_CLEAR_MS);
        }
      }
    });
    */
  }

  //T.32832 - Selecciona un camión para mostrar detalles (Google Maps)
  public seleccionarCamion(camion: ICamionTracking): void {
    this.camionSeleccionado = camion;
    
    //T.32832 - Centrar mapa en el camión seleccionado si está disponible
    if (this.map) {
      this.googleMapsHelper.centerMap(
        this.map,
        { lat: camion.latitud, lng: camion.longitud },
        this.CONFIG_MAPA.ZOOM_CAMION_SELECCIONADO
      );
    } else {
    }
  }

  //T.32832 - Limpia selección de camión (Google Maps)
  public limpiarSeleccion(): void {
    this.camionSeleccionado = null;
    //T.32832 - Volver a vista general si el mapa está disponible
    if (this.map) {
      this.googleMapsHelper.centerMap(
        this.map,
        { lat: this.garita.latitud, lng: this.garita.longitud },
        this.CONFIG_MAPA.ZOOM_INICIAL
      );
    }
  }

  //T.32832 - Obtiene clase CSS según estado del camión
  public getClaseEstado(camion: ICamionTracking): string {
    return camion.enGeofence ? 'badge-success' : 'badge-primary';
  }

  //T.32832 - Obtiene texto del estado
  public getTextoEstado(camion: ICamionTracking): string {
    return camion.enGeofence ? 'En Garita' : 'En Ruta';
  }

  //T.32832 - Obtiene cantidad de camiones en ruta
  public getCamionesEnRuta(): number {
    return this.camiones.filter(camion => !camion.enGeofence).length;
  }

  //T.32832 - Obtiene cantidad de camiones en garita
  public getCamionesEnGarita(): number {
    return this.camiones.filter(camion => camion.enGeofence).length;
  }

  //T.32832 - Obtiene porcentaje de viajes CREADO
  public getPorcentajeCreado(): number {
    const total = this.viajesCreado.length + this.viajesEnCola.length + this.viajesEnRuta.length + this.viajesRevisionHabilitada.length;
    if (total === 0) return 0;
    return Math.round((this.viajesCreado.length / total) * 100);
  }

  //T.32832 - Obtiene porcentaje de viajes en ruta
  public getPorcentajeEnRuta(): number {
    const total = this.viajesCreado.length + this.viajesEnCola.length + this.viajesEnRuta.length + this.viajesRevisionHabilitada.length;
    if (total === 0) return 0;
    return Math.round((this.viajesEnRuta.length / total) * 100);
  }

  //T.32832 - Obtiene porcentaje de viajes en cola
  public getPorcentajeEnCola(): number {
    const total = this.viajesCreado.length + this.viajesEnCola.length + this.viajesEnRuta.length + this.viajesRevisionHabilitada.length;
    if (total === 0) return 0;
    return Math.round((this.viajesEnCola.length / total) * 100);
  }

  //T.32832 - Obtiene porcentaje de viajes con revisión habilitada
  public getPorcentajeRevisionHabilitada(): number {
    const total = this.viajesCreado.length + this.viajesEnCola.length + this.viajesEnRuta.length + this.viajesRevisionHabilitada.length;
    if (total === 0) return 0;
    return Math.round((this.viajesRevisionHabilitada.length / total) * 100);
  }

  //T.32832 - Obtiene porcentaje de camiones en garita (deprecated)
  public getPorcentajeEnGarita(): number {
    if (this.camiones.length === 0) return 0;
    return Math.round((this.getCamionesEnGarita() / this.camiones.length) * 100);
  }


  /**INTEGRACION ONLY CONTROL
   * USUARIO Y BALANZA, INICIALIZA SERVICIOS Y ENVIA MENSAJES
   */
  
  //Obtiene el usuario para garita o bascula
  basculaUsuario : any;
  getUsuarioBascula(){
    const username =this.usarioActual.login2;
    this.usuarioBasculaAPI.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp?.bascula) {
          let bascula = {
            idBascula: resp.bascula, 
            estado: resp.estadoBascula, 
            desca: resp.basculaDescripcion,
            sensorId: resp.sensorId,
            apiKey: resp.apiKey,
          };
          this.basculaUsuario = bascula;

          //Verifica test de conexión siempre que tenga Api Key
          if (resp.sensorId != null) {
            this.onlyControlSensoresAPI.setIntegration_ApiKey(resp.sensorId);
          }
          return;
        }
      },
      e => {console.error('Mensaje: ', e.error.mensaje, 'Respuesta', e.error.respuesta);}
    );
  }

  mensajesMarquesinas=[]; 
  getAllMensajesMarquesinas(){
    this.logisticaAPI.getMarquesinaMensajes().subscribe(resp => {
      if(resp){
        this.mensajesMarquesinas = resp;
      }
      console.log("mensajes marquesiana", this.mensajesMarquesinas);
    });
  }

  enviarMensajeMarquesina(tipoMensaje: String){
    console.log("buscar mensaje según estado", tipoMensaje);
    let filterMnsj = this.mensajesMarquesinas.find(e=> e.tipo === tipoMensaje);
    let lineasMnsj = filterMnsj ? filterMnsj.mensaje.split(",").map(m => ({texto: m.trim()})) : [];

    if(filterMnsj.indicador > 0) this.setearSentidoBascula(filterMnsj.indicador);

    if(lineasMnsj.length == 0){
      console.info("Marquesina sin mensajes", lineasMnsj.length);
      this.utilServices.alertifyToastWar("Sin mensajes para marquesina " + filterMnsj.marquesina.codigo);
      return;
    }

    const request: IMensajesRequest = {
      codigoBascula     : filterMnsj.marquesina.codigo,
      mensajesMarquesina: lineasMnsj
    };

    this.onlyControlSensoresAPI.postMensaje(request).subscribe(
      (resp) => {
        console.log(resp);
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error de Envio de mensajes", resp.detalle, 3000);    
          return; 
        }
        this.utilServices.alertifyToastOK("Mensaje de entrada enviado a la marquesina");
      },
      (error) => {
        this.utilServices.mensajeErrorVisto("Error en establecer mensaje");
        console.log("Error en establecer mensaje", error);
      }
    );
  }

  //Recibe sentido 1 o 2 dependiente si es Entrada o Salida
  setearSentidoBascula(sentido: number){
    const request: IBasculaSentidoRequest = {
      codigoBascula: this.basculaUsuario.sensorId,
      sentido: sentido
    };
    
    this.onlyControlSensoresAPI.postSentidoBascula(request).subscribe(
      (resp) => {
        this.utilServices.alertifyToastOK("Sentido establecido");
        if(resp.error == 1){
          this.utilServices.mensajeErrorVisto("Error en establicer sentido", resp.detalle, 3000);
          return;
        }
      },
      (error) => {
        this.utilServices.mensajeErroToast("Error en establecer sentido");
        console.log("Error en establecer sentido", error);
      }
    );
  }  




}
